import React, { useState, useContext, useEffect } from 'react';
import { Form, Formik } from 'formik';
import axios from 'axios';
import * as Yup from 'yup';
import Card from '../components/common/Card';
import Hyperlink from './../components/common/Hyperlink';
import Label from './../components/common/Label';
import FormInput from './../components/FormInput';
import FormSuccess from './../components/FormSuccess';
import FormError from './../components/FormError';
import GradientBar from './../components/common/GradientBar';
import { AuthContext } from '../context/AuthContext';
import { FetchContext } from '../context/FetchContext';
import { Redirect, Link } from 'react-router-dom';
import GradientButton from '../components/common/GradientButton';
import logo from './../images/logo.png';
import { ALLOWED_COUNTRY, ALLOWED_STATE } from '../constant/server.js';

const LoginSchema = Yup.object().shape({
  email: Yup.string().required('Email is required'),
  password: Yup.string().required('Password is required'),
});

const Login = () => {
  const authContext = useContext(AuthContext);
  const fetchContext = useContext(FetchContext);
  const [loginSuccess, setLoginSuccess] = useState();
  const [loginError, setLoginError] = useState();
  const [redirectOnLogin, setRedirectOnLogin] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [isVerifyCode, setVerifyCode] = useState(false);
  const [isAllowed, setIsAllowed] = useState(true);
  const [ip, setIP] = useState('');

  const getIp = async () => {
    const ip = await axios.get('https://ipv4.seeip.org/jsonip');
    const res = await axios.get(`https://api.seeip.org/geoip/${ip.data.ip}`);
    if (
      res.data.ip !== '217.180.236.41' &&
      (!ALLOWED_COUNTRY.includes(res.data.country_code) ||
        !ALLOWED_STATE.includes(res.data.region))
    ) {
      setIsAllowed(false);
      setLoginError(
        'Your country is not allowed to access this site, please contact administrator'
      );
    }
    setIP(res.data.ip);
  };

  useEffect(() => {
    //passing getData method to the lifecycle method
    getIp();
  }, [fetchContext]);

  const submitCredentials = async credentials => {
    try {
      credentials.ip = ip;
      setLoginLoading(true);
      let response;
      if (!isVerifyCode) {
        const { data } = await fetchContext.publicAxios.post(
          `authenticate`,
          credentials
        );
        response = data;
      } else {
        if (!credentials.code) {
          setLoginError('Please enter verification code');
          return;
        }
        const { data } = await fetchContext.publicAxios.post(
          `verify`,
          credentials
        );
        response = data;
      }

      authContext.setAuthState(response);
      setLoginSuccess(response.message);
      setLoginError(null);

      setTimeout(() => {
        setRedirectOnLogin(true);
      }, 700);
    } catch (error) {
      setLoginLoading(false);
      const { data } = error.response;
      setLoginError(data.message);
      setLoginSuccess(null);
      if (data.verifyCode) {
        setVerifyCode(true);
      }
    }
  };

  return (
    <>
      {redirectOnLogin && <Redirect to="/dash" />}
      <section className="w-full sm:w-1/2 h-screen m-auto p-8 sm:pt-10">
        <GradientBar />
        <Card>
          <div className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full">
              <div>
                <div className="w-32 m-auto mb-6">
                  <img src={logo} alt="Logo" />
                </div>
                <h2 className="mb-2 text-center text-3xl leading-9 font-extrabold text-gray-900">
                  Log in to your account
                </h2>
                <p
                  className={
                    !isAllowed
                      ? 'text-gray-600 text-center disabled-link'
                      : 'text-gray-600 text-center'
                  }
                >
                  Don't have an account?{' '}
                  <Hyperlink to="signup" text="Sign up now" />
                </p>
              </div>

              <Formik
                initialValues={{
                  email: '',
                  password: '',
                  code: '',
                }}
                onSubmit={values => submitCredentials(values)}
                validationSchema={LoginSchema}
              >
                {() => (
                  <Form className="mt-8">
                    {loginSuccess && <FormSuccess text={loginSuccess} />}
                    {loginError && <FormError text={loginError} />}
                    <div>
                      <div className="mb-2">
                        <div className="mb-1">
                          <Label text="Email" />
                        </div>
                        <FormInput
                          ariaLabel="Email"
                          name="email"
                          type="text"
                          placeholder="Email"
                        />
                      </div>
                      <div>
                        <div className="mb-1">
                          <Label text="Password" />
                        </div>
                        <FormInput
                          ariaLabel="Password"
                          name="password"
                          type="password"
                          placeholder="Password"
                        />
                      </div>
                      {isVerifyCode && (
                        <div>
                          <div className="mb-1">
                            <Label text="code" />
                          </div>
                          <FormInput
                            ariaLabel="code"
                            name="code"
                            type="text"
                            placeholder="Verify"
                            autoFocus={true}
                          />
                        </div>
                      )}
                    </div>

                    <div className="mt-6 flex justify-start">
                      <div className="text-sm leading-5">
                        <Link
                          to="/forgot-password"
                          className={!isAllowed ? 'disabled-link' : ''}
                        >
                          <h5>Forgot your password?</h5>
                        </Link>
                      </div>
                    </div>

                    <div className="mt-6">
                      <GradientButton
                        type="submit"
                        text={!isVerifyCode ? 'Log In' : 'Verify'}
                        loading={loginLoading}
                        disabled={!isAllowed}
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </section>
    </>
  );
};

export default Login;
